import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { LayoutComponent } from './components/layout/layout.component';
import { DashboardMainViewComponent } from './pages/dashboard-main-view/dashboard-main-view.component';
import { AuthGuard } from './apiServices/auth/auth.guard';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

const routes: Routes = [
    { path: "login", component: LoginComponent },
    {
        path: "dashboard",
        component: LayoutComponent,
        children: [
            {
                path: "",
                component: DashboardMainViewComponent,
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: "daily-report",
        component: LayoutComponent,
        children: [
            {
                path: "",
                loadChildren:
                    "./moduleDailyReport/daily-report.module#DailyReportModule",
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: "wasa-recharge-request",
        component: LayoutComponent,
        children: [
            {
                path: "",
                loadChildren:
                    "./moduleWasaRechargeRequest/wasa-recharge-request.module#WasaRechargeRequestModule",
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: "account",
        component: LayoutComponent,
        children: [
            {
                path: "",
                loadChildren: "./moduleAccount/account.module#AccountModule",
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: "recharge",
        component: LayoutComponent,
        children: [
            {
                path: "",
                loadChildren: "./moduleRecharge/recharge.module#RechargeModule",
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: "bkashtransaction",
        component: LayoutComponent,
        children: [
            {
                path: "",
                loadChildren: "./modulebkashtransaction/bkashtransaction.module#BkashTransactionModule",
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: "water-transaction",
        component: LayoutComponent,
        children: [
            {
                path: "",
                loadChildren:
                    "./moduleWaterTransaction/water-transaction.module#WaterTransactionModule",
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: "card",
        component: LayoutComponent,
        children: [
            {
                path: "",
                loadChildren: "./moduleCard/card.module#CardModule",
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: "setting",
        component: LayoutComponent,
        children: [
            {
                path: "",
                loadChildren: "./moduleSetting/setting.module#SettingModule",
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: "Log",
        component: LayoutComponent,
        children: [
            {
                path: "",
                loadChildren: "./moduleLog/Log.module#LogModule",
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: "report",
        component: LayoutComponent,
        children: [
            {
                path: "",
                loadChildren: "./moduleReport/report.module#ReportModule",
                canActivate: [AuthGuard]
            }
        ]
    },
    { path: "", redirectTo: "login", pathMatch: "full" }
];

@NgModule({
    imports: [RouterModule.forRoot(routes,{useHash: true})
      ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
